import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaHeart, FaRegHeart } from "react-icons/fa"; // Importing heart icon for wishlist
import { useNavigate, useParams } from "react-router-dom";
import "swiper/css";
import ProductComparison from "../Components/ProductComparison";
import AboutCompany from "../Components/productListcomponents/companyContent";
import { showErrorToast, showSuccessToast } from "../utils/toaster";
import { baseurl } from "../config/url";
import { useContext } from "react";
import { DataProvider } from "../Components/ContextProvider"; // adjust the path if different

const ProductDetails = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [similarProducts, setSimilarProducts] = useState([]);
  const [error, setError] = useState("");
  const [quantity, setQuantity] = useState(1); // Add state for quantity selection
  const [isInWishlist, setIsInWishlist] = useState(false);
  const [popupMessage, setPopupMessage] = useState(null);
  const [selectedSeller, setSelectedSeller] = useState(null);
  const [showSellerDetails, setShowSellerDetails] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [userDetails, setUserDetails] = useState(null); // Store user details
  const [zoomStyle, setZoomStyle] = useState({});
  const [zoomVisible, setZoomVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [wishlistItems, setwishlistItems] = useState([]);

  useEffect(() => {
    const credentials = localStorage.getItem("usercredentials");

    if (credentials) {
      try {
        const parsed = JSON.parse(credentials);
        setUserDetails({
          name: parsed.name || "",
          email: parsed.email || "",
          phone: parsed.mobile || "", // Make sure your backend expects `phone` not `mobile`
          location: "", // optional, will be filled during form if needed
        });
      } catch (err) {
        console.error(
          "Failed to parse usercredentials from localStorage:",
          err
        );
      }
    }
  }, []);

  const { issetLoginDialogOpen, setisSignup, setshowotpcomponent } =
    useContext(DataProvider);
  const promptLoginDialog = () => {
    setisSignup(false);
    setshowotpcomponent(false);
    issetLoginDialogOpen(true);
  };

  const getUserLocation = async () => {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        return resolve(getLocationFromIP());
      }

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          try {
            const res = await fetch(
              `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
            );
            const data = await res.json();
            const location = `${data.city || data.locality}, ${
              data.principalSubdivision
            }, ${data.countryName}`;
            resolve(location);
          } catch (err) {
            console.error("Reverse geocoding failed:", err);
            resolve(getLocationFromIP());
          }
        },
        async (error) => {
          console.warn(
            "Geolocation permission denied or unavailable:",
            error.message
          );
          resolve(await getLocationFromIP());
        }
      );
    });
  };

  // fallback to IP-based
  const getLocationFromIP = async () => {
    try {
      const res = await fetch("https://ipapi.co/json/");
      const data = await res.json();
      return `${data.city}, ${data.region}, ${data.country_name}`;
    } catch (err) {
      console.error("IP-based location fetch failed:", err);
      return "Unknown";
    }
  };

  // Record user interest
  const recordUserInterest = async () => {
    const token = localStorage.getItem("token");
    if (!token || !productId) return;

    try {
      const location = await getUserLocation();
      await axios.post(
        `${baseurl}/api/user/interested`,
        {
          productId,
          location,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("User interest recorded.");
    } catch (error) {
      console.error("Failed to record interest:", error.message);
    }
  };

  const getWishlist = async () => {
    const userId = localStorage.getItem("userId");
    if (!userId) return;
    try {
      const userId = localStorage.getItem("userId"); // Assuming userId is stored in localStorage
      const response = await axios.get(
        `${baseurl}/api/wishlist/get-wishlist/${userId}`
      );

      const data = response?.data?.items || [];
      const isProductExist = data.some((p) => p?.productId?._id === productId); // Strict equality for comparison

      console.log(isProductExist, "isProductExist", productId);

      setIsInWishlist(isProductExist);
      setwishlistItems(data);
    } catch (error) {
      console.error("Error fetching wishlist:", error);
    }
  };

  useEffect(() => {
    const fetchProductDetails = async () => {
      console.log(productId, "productId");

      try {
        const response = await axios.get(
          `${baseurl}/api/seller/details/${productId}`
        );

        console.log("📦 Product fetched:", response.data);
        console.log("📋 Hire Charges:", response.data.hireCharges); // <-- Add this line here

        setProduct(response.data);
        setQuantity(response.data.minquantity); // Set initial quantity to the minimum
        setSelectedImage(response.data.image); // main image becomes default
        fetchSimilarProducts(response.data.name);
      } catch (err) {
        console.error("Error fetching product details:", err);
        setError("Error fetching product details.");
      }
    };

    if (productId) fetchProductDetails();
    recordUserInterest();
  }, [productId]);

  const fetchSimilarProducts = async (productName) => {
    try {
      const response = await axios.get(
        `${baseurl}/api/seller/get-similar-products?name=${encodeURIComponent(
          productName
        )}`
      );
      // setSimilarProducts(response.data);
      const res = response.data;
      const formattedData = Array.isArray(res)
        ? res
        : Array.isArray(res.products)
        ? res.products
        : [];
      setSimilarProducts({ products: formattedData });

      console.log("Similar Products API Response:", response.data);
    } catch (err) {
      console.error("Error fetching similar products:", err);
    }
  };

  //end
  // Handle Wishlist Toggle
  const handleAddToWishlist = async () => {
    const userId = localStorage.getItem("userId");

    try {
      if (isInWishlist) {
        await axios.post(`${baseurl}/api/wishlist/remove`, {
          userId,
          productId,
        });
        setIsInWishlist(false);
        showSuccessToast("Removed from wishlist");
      } else {
        await axios.post(`${baseurl}/api/wishlist/add`, {
          userId,
          productId,
        });
        setIsInWishlist(true);
        showSuccessToast("Added to wishlist");
      }
    } catch (err) {
      showErrorToast("Error managing wishlist:", err);
    }
  };

  const handleAddToCart = async () => {
    const userId = localStorage.getItem("userId");

    if (!userId) {
      showErrorToast("Please login to proceed!");
      return;
    }
    try {
      const location = await getUserLocation(); // ✅ get live location
      const response = await axios.post(`${baseurl}/api/cart/add-to-cart`, {
        userId,
        location,
        items: [{ productId, quantity }],
      });

      if (
        response.data.message &&
        response.data.message.includes(
          "available for sale directly by the seller"
        )
      ) {
        setPopupMessage(response.data.message);
        setSelectedSeller(response.data.sellerDetails);
      } else {
        showSuccessToast(`${product.name} added to cart!`);
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ||
        "An error occurred while adding to the cart. Please try again.";
      showErrorToast(errorMessage);
    }
  };
  // end

  const closePopup = () => {
    setPopupMessage(null);
    setSelectedSeller(null);
  };

  const handleShowSellerDetails = () => {
    setShowSellerDetails(true);
    setPopupMessage(null);
  };

  // Update quantity using + and - buttons
  const increaseQuantity = () => {
    if (product) {
      if (quantity < product.maxquantity && quantity < product.stock) {
        setQuantity(quantity + 1);
      } else if (quantity >= product.stock) {
        showSuccessToast(
          `Only ${product.stock} items are available in stock. Please adjust your order.`
        );
      } else {
        showSuccessToast(
          `You can only order up to ${product.maxquantity} items. Thank you for understanding!`
        );
      }
    }
  };

  const decreaseQuantity = () => {
    if (product && quantity > product.minquantity) {
      setQuantity(quantity - 1);
    } else {
      showSuccessToast(
        `The minimum quantity you can order is ${product.minquantity}. Adjust your selection accordingly!`
      );
    }
  };

  useEffect(() => {
    getWishlist();
  }, []);

  const [showBestPricePopup, setShowBestPricePopup] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    location: "",
    file: null,
  });

  const handleBestPriceChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // const handleBestPriceSubmit = async () => {
  //   try {
  //     // Example: send this data to your backend (optional)
  //     await axios.post(`${baseurl}/api/interested-users`, {
  //       ...formData,
  //       productId: productId,
  //       saleType: product.saleType,
  //     });

  //     showSuccessToast("Thank you! Our team will contact you shortly.");
  //     setShowBestPricePopup(false);
  //     setFormData({ name: "", email: "", phone: "", location: "" });
  //   } catch (err) {
  //     showErrorToast("Something went wrong. Please try again.");
  //   }
  // };

  // Combine main image + other images

  const handleBestPriceSubmit = async () => {
    const userId = localStorage.getItem("userId");

    if (!userId) {
      promptLoginDialog(); // 👈 Show login dialog
      return;
    }

    if (!userDetails) {
      showErrorToast("User details are missing. Please login again.");
      return;
    }

    setIsSubmitting(true);

    //console.log("🧪 Submit button clicked");

    try {
      const sellerId = product?.seller?._id;

      const formDataToSend = new FormData();
      formDataToSend.append("name", userDetails?.name || "");
      formDataToSend.append("email", userDetails?.email || "");
      formDataToSend.append("phone", userDetails?.phone || "");
      formDataToSend.append("location", userDetails?.location || "");
      formDataToSend.append("productId", productId);
      formDataToSend.append("saleType", product.saleType);
      formDataToSend.append("userId", userId);
      formDataToSend.append("sellerId", sellerId);
      if (formData.file) {
        formDataToSend.append("file", formData.file);
      }

      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${baseurl}/api/seller/interested-users`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      showSuccessToast("Thank you! Our team will contact you shortly.");
      setShowBestPricePopup(false);
      setFormData({ name: "", email: "", phone: "", location: "", file: null });
    } catch (err) {
      console.error("Submission error:", err);
      showErrorToast("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false); // ✅ STOP LOADING
    }
  };

  const allImages = [
    ...(product?.image ? [product.image] : []),
    ...(product?.images || []),
  ];

  // console.log("📦 Fallback product for comparison:", product);

  const handleMouseMove = (e) => {
    const bounds = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - bounds.left) / bounds.width) * 100;
    const y = ((e.clientY - bounds.top) / bounds.height) * 100;

    setZoomStyle({
      // backgroundImage: `url(data:${selectedImage?.contentType};base64,${selectedImage?.data})`,
      backgroundImage: `url(${selectedImage})`,
      backgroundPosition: `${x}% ${y}%`,
      backgroundSize: "300%", // Increased from 200% to 300% for more zoom
    });
  };

  const handleFileChange = (e) => {
  const file = e.target.files[0];
  const maxSize = 5 * 1024 * 1024; // 5 MB

  if (file && file.size > maxSize) {
    showErrorToast("File size exceeds 5MB. Please upload a smaller file.");
    return;
  }

  setFormData((prev) => ({ ...prev, file }));
};


  return (
    <div className="container mx-auto px-4 py-8 mt-24 capitalize">
      {error && <p className="text-red-500 text-center">{error}</p>}
      {product ? (
        <>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="flex space-x-4">
              <div className="flex-shrink-0 ">
                {/* Thumbnails on the left side */}
                {/* <div className="space-y-4">
                  {product?.images?.map((image, index) => (
                    <img
                      key={index}
                      src={`data:${image?.contentType};base64,${image?.data}`}
                      alt={`Product image ${index + 1}`}
                      className="rounded-lg shadow-md max-w-24 max-h-24 object-cover "
                    />
                  ))}
                </div> */}
                <div className="space-y-4">
                  {allImages.map((image, index) => (
                    <img
                      key={index}
                      // src={`data:${image?.contentType};base64,${image?.data}`}
                      //  src={product.image}
                      src={image}
                      alt={`Thumbnail ${index + 1}`}
                      onClick={() => setSelectedImage(image)}
                      className={`rounded-lg shadow-md max-w-24 max-h-24 object-cover cursor-pointer border-2 ${
                        selectedImage === image
                          ? "border-blue-500"
                          : "border-transparent"
                      }`}
                    />
                  ))}
                </div>
              </div>

              <div className="flex-grow">
                {/* Main product image on the right side */}
                {/* <img
                  src={`data:${product?.image?.contentType};base64,${product?.image?.data}`}
                  alt={product.name}
                  className="rounded-lg shadow-md w-full object-cover"
                /> */}
                {/* {selectedImage && (
                  <img
                    src={`data:${selectedImage?.contentType};base64,${selectedImage?.data}`}
                    alt={product.name}
                    className="rounded-lg shadow-md w-full object-cover"
                  />
                )} */}
                {selectedImage && (
                  <div
                    className="relative w-full"
                    onMouseMove={handleMouseMove}
                    onMouseEnter={() => setZoomVisible(true)}
                    onMouseLeave={() => setZoomVisible(false)}
                  >
                   <img
                        // src={`data:${selectedImage?.contentType};base64,${selectedImage?.data}`}
                        src={selectedImage}
                        alt={product.name}
                        className="rounded-lg shadow-md w-full object-cover"
                          loading="lazy"
                          decoding="async"
                             width="800"          // set to your typical image width
                            height="600"         // set to your typical image height (keeps aspect ratio)
                            sizes="(max-width:640px) 100vw, (max-width:1024px) 80vw, 800px"
                            fetchpriority="auto"
                    />  


                    {/* 🔍 Enlarged Zoom Preview Box */}
                    {zoomVisible && (
                      <div
                        className="absolute top-0 left-full ml-4 w-[500px] h-[500px] border border-gray-300 rounded shadow-lg bg-no-repeat bg-white z-50"
                        style={zoomStyle}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Product Details */}
            <div>
              <div className="flex justify-between items-center">
                <h3 className="text-3xl font-bold">{product.name}</h3>
                {isInWishlist ? (
                  <FaHeart
                    className="text-red-600 cursor-pointer"
                    size={24}
                    onClick={handleAddToWishlist}
                  />
                ) : (
                  <FaRegHeart
                    className="text-gray-600 cursor-pointer"
                    size={24}
                    onClick={handleAddToWishlist}
                  />
                )}
              </div>

              {product.saleType?.toLowerCase() === "sale by bestprice" ? (
                <button
                  className="mt-2 text-blue-600 underline text-lg font-semibold"
                  onClick={() => {
                    const userId = localStorage.getItem("userId");
                    if (!userId) {
                      promptLoginDialog(); // Trigger login dialog
                    } else {
                      setShowBestPricePopup(true); // Proceed if logged in
                    }
                  }}
                >
                  Ask for Best Price
                </button>
              ) : (
                <p className="text-xl font-semibold text-gray-700 mt-2">
                  Price: ₹{product.price}
                </p>
              )}

              <p className="text-gray-600 mt-4 uppercase">
                {product.stock} in stock
              </p>
              <div className="mt-4">
                <p>
                  Description:{" "}
                  {product.description || "No description available."}
                </p>
                <p>Category: {product.category?.name}</p>
                <p>Subcategory: {product.subcategory?.name}</p>
                <p>Min Quantity : {product.minquantity}</p>
                <p>Max Quantity : {product.maxquantity}</p>
                {product.priceUnit && (
  <p>
   Per Unit: {product.priceUnit.replace(/^Per/, "")}
  </p>
)}
                {product.specifications &&
                  product.specifications.length > 0 && (
                    <div className="mb-4">
                      <h4 className="font-medium text-lg text-gray-700">
                        Specifications:
                      </h4>
                      <ul className="list-disc ml-6 text-gray-600">
                        {product.specifications.map((spec, index) => (
                          <li key={index}>
                            <strong>{spec.key}:</strong> {spec.value}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                <p className="text-xl font-semibold text-gray-700 mt-2">
                  Sale Type: {product.saleType}{" "}
                </p>

                {/* Conditionally render Sale Product */}
                {product.saleType &&
                product.saleType.trim().toLowerCase() === "sale by seller" ? (
                  <>
                    <p className="text-xl font-semibold text-gray-700 mt-2">
                      <strong>Sale Product:</strong> {product.saleProduct}
                    </p>

                    {product.saleProduct === "Hire" && (
                      <div className="text-gray-700 mt-2">
                        <p className="text-gray-700 mt-2">
                          <strong>This product is available for hire.</strong>
                          <br />
                          <p>
                            If you're interested in this product, click on{" "}
                            <strong>Add to Cart</strong> to proceed.
                          </p>
                          <p>
                            <strong>Hire Charges:</strong>
                          </p>
                          {/* <ul>
                            <li>
                              <strong>Per Day:</strong> ₹
                              {product.hireCharges.perDay}
                            </li>
                            <li>
                              <strong>Per Week:</strong> ₹
                              {product.hireCharges.perWeek}
                            </li>
                            <li>
                              <strong>Per Month:</strong> ₹
                              {product.hireCharges.perMonth}
                            </li>
                          </ul> */}
                          <ul>
                            {product.hireCharges.perDay > 0 && (
                              <li>
                                <strong>Per Day:</strong> ₹
                                {product.hireCharges.perDay}
                              </li>
                            )}
                            {product.hireCharges.perWeek > 0 && (
                              <li>
                                <strong>Per Week:</strong> ₹
                                {product.hireCharges.perWeek}
                              </li>
                            )}
                            {product.hireCharges.perMonth > 0 && (
                              <li>
                                <strong>Per Month:</strong> ₹
                                {product.hireCharges.perMonth}
                              </li>
                            )}
                          </ul>
                        </p>
                      </div>
                    )}

                    <p className="text-gray-700 mt-2">
                      <strong>Sold By :</strong> {product.seller?.companyName}
                    </p>
                  </>
                ) : (
                  <p className="text-gray-700 mt-2">
                    {/* <strong>This product is available for direct sale by OGCS Buildpro.</strong> */}
                  </p>
                )}
              </div>

              {product?.saleType?.toLowerCase() === "sale by bestprice" && (
                <div className="mt-4">
                  <label className="block text-gray-700 font-medium mb-1">
                    Upload Your Requirement PDF/Excel (optional)
                  </label>
                  <input
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png,.xlsx,.xls"
                    // onChange={(e) =>
                    //   setFormData((prev) => ({
                    //     ...prev,
                    //     file: e.target.files[0],
                    //   }))
                    // }
                    onChange={handleFileChange}
                    className="block w-full border border-gray-300 rounded p-2"
                  />
                  {formData.file && (
                    <p className="text-sm text-gray-500 mt-2">
                      Selected file: {formData.file.name}
                    </p>
                  )}

                  {/* ✅ Submit Button */}
                  <button
                    className="mt-4 w-full px-6 py-2 bg-green-600 text-white rounded-md shadow hover:bg-green-700 transition duration-200"
                    onClick={handleBestPriceSubmit}
                  >
                    Submit
                  </button>
                </div>
              )}
              {/* Quantity Selector */}
              <div className="flex items-center mt-6 gap-2">
                <button
                  className="px-4 py-0 bg-gray-200 border border-gray-300 rounded-l"
                  onClick={decreaseQuantity}
                >
                  -
                </button>
                <input
                  type="text"
                  value={quantity}
                  readOnly
                  className="w-12 text-center border border-gray-300"
                />
                <button
                  className="px-4 py-0 bg-gray-200 border border-gray-300 rounded-r"
                  onClick={increaseQuantity}
                >
                  +
                </button>
              </div>

              {/* Add to Cart */}
              <button
                className="mt-6 w-1/2 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                onClick={handleAddToCart}
              >
                Add to Cart
              </button>
            </div>
          </div>

          {showBestPricePopup && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white p-6 rounded-lg shadow-md w-[90%] max-w-md relative">
                <h3 className="text-xl font-bold mb-4 text-center text-gray-800">
                  Ask For Best Price
                </h3>

                <div className="text-gray-700 text-base space-y-2">
                  <p>
                    📧 <strong>Email:</strong> salesogcspvtltd@gmail.com
                  </p>
                  <p>
                    📞 <strong>Phone No:</strong> +91 9967621235
                  </p>
                  <p>
                    🏢 <strong>Company:</strong> OGCS Pvt. Ltd.
                  </p>
                  <p className="mt-4">
                    📢 <strong>Contact our team</strong> to get the best price
                    for this product.
                  </p>
                </div>

                {product?.saleType?.toLowerCase() === "sale by bestprice" && (
                  <div className="mt-4">
                    <label className="block text-gray-700 font-medium mb-1">
                      Upload Your Requirement PDF/Excel (optional)
                    </label>
                    <input
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      // onChange={(e) =>
                      //   setFormData((prev) => ({
                      //     ...prev,
                      //     file: e.target.files[0],
                      //   }))
                      // }
                      onChange={handleFileChange}

                      className="block w-full border border-gray-300 rounded p-2"
                    />
                    {/* ✅ Submit Button */}
                    <button
                      className="mt-4 w-full px-6 py-2 bg-green-600 text-white rounded-md shadow hover:bg-green-700 transition duration-200"
                      onClick={handleBestPriceSubmit}
                    >
                      Submit
                    </button>
                  </div>
                )}

                <div className="flex justify-end mt-6">
                  <button
                    className="px-6 py-2 bg-blue-600 text-white rounded-md shadow hover:bg-blue-700 transition duration-200"
                    onClick={() => setShowBestPricePopup(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}

          {popupMessage && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white p-8 rounded-lg shadow-lg w-96">
                {/* <h3 className="text-lg font-semibold text-gray-800">Notification</h3> */}
                <p className="text-gray-700 mt-4">{popupMessage}</p>
                <div className="flex justify-end mt-6 gap-4">
                  <button
                    className="px-6 py-2 bg-blue-600 text-white rounded-md shadow hover:bg-blue-700 transition duration-200"
                    onClick={handleShowSellerDetails}
                  >
                    OK
                  </button>
                  <button
                    className="px-6 py-2 bg-red-600 text-white rounded-md shadow hover:bg-red-700 transition duration-200"
                    onClick={closePopup}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}

          {showSellerDetails && selectedSeller && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6 relative">
                <button
                  className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
                  onClick={() => setShowSellerDetails(false)}
                >
                  ✖
                </button>

                {/* Seller Details */}
                <div className="text-center">
                  <h3 className="text-xl font-semibold text-gray-800">
                    Seller Information
                  </h3>
                  <p className="text-gray-600 mt-2">
                    Know more about the seller of this product.
                  </p>
                </div>

                <div className="mt-6 space-y-4">
                  <div className="flex items-center">
                    <span className="font-semibold text-gray-700 w-1/3">
                      Name:
                    </span>
                    <span className="text-gray-600">{selectedSeller.name}</span>
                  </div>
                  <div className="flex items-center">
                    <span className="font-semibold text-gray-700 w-1/3">
                      Email:
                    </span>
                    <span className="text-gray-600">
                      {selectedSeller.email}
                    </span>
                  </div>
                  <div className="flex items-center">
                    <span className="font-semibold text-gray-700 w-1/3">
                      Mobile:
                    </span>
                    <span className="text-gray-600">
                      {selectedSeller.mobile}
                    </span>
                  </div>
                  <div className="flex items-center">
                    <span className="font-semibold text-gray-700 w-1/3">
                      Company:
                    </span>
                    <span className="text-gray-600">
                      {selectedSeller.companyName}
                    </span>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex justify-end mt-6 space-x-4">
                  <button
                    className="px-6 py-2 bg-red-600 text-white rounded-md shadow hover:bg-red-700 transition duration-200"
                    onClick={() => setShowSellerDetails(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="mt-20">
            {/* <ProductComparison data={similarProducts} /> */}

            <ProductComparison
              data={
                similarProducts.products && similarProducts.products.length > 0
                  ? similarProducts
                  : { products: [product] }
              }
            />
          </div>
        </>
      ) : (
        !error && (
          <p className="text-center text-xl">Loading product details...</p>
        )
      )}
      <div className="mt-20">
        <AboutCompany />
      </div>
      {/* ✅ Add Loader Here */}
      {isSubmitting && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded shadow text-center">
            <p className="text-lg font-medium text-gray-700">
              Submitting your request...
            </p>
            <div className="mt-4 loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-12 w-12 animate-spin mx-auto"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductDetails;
